<script setup lang="ts">
import type { CmsElementBioCircle } from "~/composables/useCustom";

const props = defineProps<{
  content: CmsElementBioCircle;
}>();

const { data } = props.content;
const { content } = data;
</script>
<template>
  <div v-html="content"></div>
</template>
